export const hexToRgba = (hex, alpha = 1, object = false) => {
    if (!hex) return;
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    if (object) return { r, g, b, a: alpha };
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
